import React, { useState, FC, useRef } from 'react';
import Lightbox from 'react-image-lightbox';
import { SafeAnyType } from 'src/utils/safeAny';

import { ChildrenPropType } from 'src/utils/types';

type Props = {
  render: (d: { onShow: () => void; onShowWithSrc: (src?: string) => SafeAnyType }) => ChildrenPropType;
  src?: string | null;

  imagePadding?: number;
};

export const UiElementLightbox: FC<Props> = ({ src, render, imagePadding = 50 }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [customSrc, setCustomSrc] = useState(src);

  const { current: onShow } = useRef((v: boolean) => () => {
    setShowPreview(v);
  });

  const { current: onShowWithSrc } = useRef((v: boolean) => (customSrc?: string) => () => {
    if (customSrc) {
      setCustomSrc(customSrc);
    }

    onShow(v)();
  });

  return (
    <>
      {render({ onShow: onShow(true), onShowWithSrc: onShowWithSrc(true) })}
      {showPreview && customSrc && (
        <Lightbox mainSrc={customSrc} onCloseRequest={onShow(false)} enableZoom={false} imagePadding={imagePadding} />
      )}
    </>
  );
};
